'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HoldingsProbe = require('./components/HoldingsProbe.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HoldingsProbe).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/probes/lib/components/holdings-probe/index.js
// module id = 1453
// module chunks = 1